import React, { useEffect, useState } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Button, Typography, Chip, alertTitleClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { brown, green, blue, orange, purple, red } from '@mui/material/colors';
import moment from 'moment';
import CenterSelect from "./CenterSelect";
import axios from 'axios';
import { configState, loginState } from "../lib/State";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ko } from "date-fns/locale";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import add_comma from "../lib/add_comma";
import ReportCouponDialog from "./ReportCouponDialog";

const Container = styled(Box)`
    max-width: 1100px;
    .MuiTableHead-root .MuiTableRow-root { background:${brown[200]} } /* 제목 셀 */
    .MuiTableHead-root .MuiTableCell-root { text-align: center; color: white; } 
    .MuiTableBody-root .MuiTableCell-root { padding:0 ;} 
    .green { background: ${green[500]} }
    .blue { background: ${blue[500]} }
    .orange { background: ${orange[500]} }
`;

const token = get_token();
const cid = get_cid();

export default function ReportCardList(props) {

    const { tcidParent, login } = props;
    const [tcid, setTcid] = useState('');
    const [tm, setTm] = useState(moment().format('YYYY-MM-01'));
    const [rows, setRows] = useState([]);
    const [sum, setSum] = useState({
        trial: 0,
        bonus: 0,
        class: 0,
        amount: 0,
    });
    const [open, setOpen] = useState(false);
    const [dt, setDt] = useState(moment().format("YYYY-MM-01"));
    const [edate, setEdate] = useState('');

    const next_month = () => {
        setTm(moment(tm).add(1, 'month').format('YYYY-MM-DD'));
    }

    const previous_month = () => {
        setTm(moment(tm).add(-1, 'month').format('YYYY-MM-DD'));
    }


    // 데이타 로드
    useEffect(() => {
        async function fetchData() {
            if (tcid === '') return;
            if (tm === '') return;
            let trial_sum = 0;
            let bonus_sum = 0;
            let class_sum = 0;
            let sale_sum = 0;
            let origin_sum = 0;
            let total_amount =0; 

            let result = await axios.post(configState.api + "/chart/report_coupon", {
                token: token,
                cid: cid,
                tcid: tcid,
                tm: tm
            });
            if (result.data.success === 1) {
                setRows(result.data.rows);

                // 쿠폰합계
                result.data.rows.forEach(el => {
                    el.forEach(el1 => {
                        trial_sum += parseInt(el1.trial_count);
                        bonus_sum += parseInt(el1.bonus_count);
                        class_sum += parseInt(el1.class_count);
                        total_amount += parseInt(el1.total_amount);                        
                    });
                });
                setSum({
                    trial: trial_sum,
                    bonus: bonus_sum,
                    class: class_sum,
                    amount: total_amount,
                });
            }
        }
        fetchData();
    }, [tcid, tm]);

    const calendar_click = (value) => {
        setDt(value);
        setEdate(value);
        setOpen(true);
    }

    const listAll = () => { // 한달 모두보기        
        setDt( moment(tm).startOf('month').format("YYYY-MM-DD") );
        setEdate( moment(tm).endOf('month').format("YYYY-MM-DD") );
        setOpen(true);        
    }

    return (
        <Container>
            
            <ReportCouponDialog open={open} setOpen={setOpen} sdate={dt} edate={edate} tcid={tcid} login={login}></ReportCouponDialog>

            <Box mt={1}>
            </Box>


            <Box display="flex" alignItems="center">
                <Box>
                    <Typography variant="h4">
                        {moment(tm).format('YYYY-MM')}
                    </Typography>
                </Box>
                <Box display="flex" ml={2} >
                    <Box>
                        <Button variant="contained" onClick={previous_month}>지난달</Button>
                    </Box>
                    <Box ml={1}>
                        <Button variant="contained" onClick={next_month}>다음달</Button>
                    </Box>

                    <Box ml={1}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                            <DatePicker
                                locale={ko}
                                views={['year', 'month']}
                                label="Year and Month"
                                value={tm}
                                onChange={(newValue) => {
                                    setTm(moment(newValue).format('YYYY-MM-DD'));
                                }}
                                renderInput={(params) => <TextField {...params} helperText={null} size="small" />}
                            />
                        </LocalizationProvider>
                    </Box>

                </Box>
            </Box>

            <Box mt={3}>
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                    <Chip label={sum.trial} sx={{ background: green[500], color: 'white', mr: 0.5 }}></Chip> 체험쿠폰
                    <Chip label={sum.class} sx={{ background: blue[500], color: 'white', mr: 0.5, ml: 1 }}></Chip> 클래스쿠폰 
                    <Chip label={sum.bonus} sx={{ background: orange[500], color: 'white', mr: 0.5, ml: 1 }}></Chip> 보너스쿠폰
                    <Chip label={add_comma(sum.amount)} sx={{ background: purple[300], color: 'white', mr: 0.5, ml: 1 }} onClick={listAll}></Chip> 쿠폰매출 합계
                    <Box ml={1}>
                        <CenterSelect login={login} tcidParent={tcid} setTcidParent={setTcid} />
                    </Box>
                </Box>
            </Box>

            <Box mt={2}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell><Typography color={red[500]}>일</Typography></TableCell>
                                <TableCell>월</TableCell>
                                <TableCell>화</TableCell>
                                <TableCell>수</TableCell>
                                <TableCell>목</TableCell>
                                <TableCell>금</TableCell>
                                <TableCell><Typography color={blue[500]}>토</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((item, index) => {
                                return <TableRow key={index}>
                                    {item.map((item1, index1) => {

                                        // 선택한 달                                     
                                        const sdate = moment(tm).startOf('month').format("YYYY-MM-DD");
                                        const edate = moment(tm).endOf('month').format("YYYY-MM-DD");

                                        if (item1.dt >= sdate && item1.dt <= edate) {
                                            return <TableCell sx={{cursor:'hand', cursor:'pointer'}} component="th" scope="row" key={index1} onClick={ ()=>calendar_click(item1.dt) } ><Box m={0.6} minHeight={100} borderRight={index1 !== 6 ? 1 : 0} borderColor={brown[100]}>
                                                <Box display="flex" justifyContent="space-between">
                                                    <Box>{moment(item1.dt).format('D')}</Box>
                                                    <Box display="flex" mr={0.3}>
                                                        <Chip label={add_comma(item1.trial_count)} sx={{ color: 'white', background: item1.trial_count > 0 ? green[500] : green[50] }}></Chip>
                                                        <Chip label={add_comma(item1.class_count)} sx={{ ml: 0.2, color: 'white', background: item1.class_count > 0 ? blue[500] : blue[50] }}></Chip>
                                                        <Chip label={add_comma(item1.bonus_count)} sx={{ ml: 0.2, color: 'white', background: item1.bonus_count > 0 ? orange[500] : orange[50] }}></Chip>
                                                    </Box>
                                                </Box>
                                                <Box textAlign="right" mt={1}>
                                                    <Chip label={add_comma(item1.total_amount)} sx={{ background: item1.total_amount > 0 ? purple[300] : purple[50], color: 'white', mr: 0.5 }}></Chip>
                                                </Box>
                                            </Box></TableCell>
                                        } else {
                                            return <TableCell component="th" scope="row" key={index1}><Box m={0.6} minHeight={90} borderRight={index1 !== 6 ? 1 : 0} borderColor={brown[100]}>
                                                <Box display="flex" justifyContent="space-between">
                                                    &nbsp;
                                                </Box>
                                            </Box></TableCell>
                                        }
                                    })}
                                </TableRow>
                            })}

                            {rows.length === 0 && <TableRow>
                                <TableCell colSpan={7} sx={{ textAlign: "center", height: 60 }}>자료가 없습니다.</TableCell>
                            </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Container>
    );
}